import React from 'react'
import ConDerechos from './Components/ConDerechos'
import SinDerechos from './Components/SinDerechos'
import Proximo from './Components/Proximo'
import Finalizado from './Components/Finalizado'

var CON_DERECHOS = 'ConDerechos'
var SIN_DERECHOS = 'SinDerechos'
var PROXIMO      = 'Proximo'
var FINALIZADO   = 'Finalizado'

/**
 * MatchCard
 * Delegador — elige el sub-componente según `state`.
 * Figma: 155:20666 (ConDerechos) / 155:22732 (SinDerechos) /
 *        155:21426 (Proximo)     / 155:20419 (Finalizado)
 *
 * Props:
 *  state            {string}  — 'ConDerechos' | 'SinDerechos' | 'Proximo' | 'Finalizado'
 *  homeTeam         {object}  — { name, flagUrl, color }
 *  awayTeam         {object}  — { name, flagUrl, color }
 *  competition      {string}
 *  competitionGroup {string}
 *  homeScore        {number}  — ConDerechos, SinDerechos
 *  awayScore        {number}  — ConDerechos, SinDerechos
 *  liveMinute       {string}  — ConDerechos  e.g. "56'"
 *  liveTime         {string}  — SinDerechos  e.g. "00'+00'"
 *  dateTime         {string}  — Proximo / Finalizado  e.g. "16 DE JUNIO | 19:00 / ARG"
 *  hasRightsBadge   {bool}    — Finalizado: muestra badge verde "G"
 */
function MatchCard (props) {
  const state = props.state || PROXIMO

  if (state === CON_DERECHOS) return <ConDerechos {...props} />
  if (state === SIN_DERECHOS) return <SinDerechos {...props} />
  if (state === FINALIZADO)   return <Finalizado  {...props} />
  return <Proximo {...props} />
}

MatchCard.CON_DERECHOS = CON_DERECHOS
MatchCard.SIN_DERECHOS = SIN_DERECHOS
MatchCard.PROXIMO      = PROXIMO
MatchCard.FINALIZADO   = FINALIZADO

export default MatchCard




// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Paises/components/CountryDetailsModal/Components/CountryDetailsBody/Components/MatchCard/index.jsx